import { createRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Route as appRoute } from '../../_app'
import { useRequireAdmin } from '../../../lib/me-context'
import { AdminShell } from '../../../components/admin/AdminShell'
import { AdminOrgTable } from '../../../components/admin/AdminOrgTable'

/**
 * Admin organizations view (`/admin/organizations`) — survey every organization
 * on the platform with its owner and user/quiz counts (read-only oversight).
 * Guarded by {@link useRequireAdmin}.
 */
export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: '/admin/organizations',
  component: AdminOrganizationsPage,
})

function AdminOrganizationsPage() {
  const { t } = useTranslation('admin')
  const isAdmin = useRequireAdmin()

  if (!isAdmin) {
    return null
  }

  return (
    <AdminShell active="organizations" title={t('organizationsTitle')}>
      <AdminOrgTable />
    </AdminShell>
  )
}
